import React from "react";
import { Router, Route, Switch } from "react-router-dom";
import history from "../history.js";

import TaskBar from "./TaskBar";
import Home from "./Home";
import About from "./About";
import SkillsAndExperience from "./SkillsAndExperience";
import Projects from "./Projects";
import Contact from "./Contact";

import "../style/App.css";

const App = () => {
	return (
		<div>
			<Router history={history}>
				<Switch>
					<Route path="/" exact component={Home} />
					<Route path="/about" exact component={About} />
					<Route
						path="/skills-experience"
						exact
						component={SkillsAndExperience}
					/>
					<Route path="/projects" exact component={Projects} />
					<Route path="/contact" exact component={Contact} />
				</Switch>
				<TaskBar />
			</Router>
		</div>
	);
};

export default App;
